import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@react/react-spectrum/Button';
import Heading from '@react/react-spectrum/Heading';
import Info from '@react/react-spectrum/Icon/Info';
import Label from '@react/react-spectrum/Label';
import Link from '@react/react-spectrum/Link';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import Tooltip from '@react/react-spectrum/Tooltip';

import { RootContext } from '../../../root/RootContext';
import ConfigureControls from './ConfigureControls';
import { PATHS } from 'config/constants';

import './AEPSidebar.scss';

export default function AEPSidebar() {
  const history = useHistory();
  const { state } = useContext(RootContext);

  const { id, imsOrg, sandboxName } = state.activeAEP;

  const twilioPrefix = ['number', 'string'].includes(typeof id)
    ? ('' + id).padStart(5, '0')
    : '---';

  return (
    <div className="aep-sidebar">
      <section className="heading-section">
        <Heading size={2}>{sandboxName}</Heading>

        {sandboxName === 'prod' ? (
          <Label variant="blue">PRODUCTION</Label>
        ) : (
          <Label variant="grey">DEVELOPMENT</Label>
        )}

        <Heading variant="subtitle3">Experience Platform</Heading>
      </section>

      <ConfigureControls id={id} imsOrg={imsOrg} sandboxName={sandboxName} />

      <section>
        <Heading variant="subtitle1">Properties</Heading>
        <Heading variant="subtitle3">URL</Heading>
        <div style={{ overflowWrap: 'break-word' }}>
          <Link
            href={`https://experience.adobe.com/#/@${imsOrg.tenantID}/sname:${sandboxName}/platform/home`}
            target="_blank">
            {`https://experience.adobe.com/#/@${imsOrg.tenantID}/sname:${sandboxName}/platform/home`}
          </Link>
        </div>
      </section>

      <section>
        <Heading variant="subtitle1">Misc</Heading>
        <div className="property">
          <div style={{ display: 'flex' }}>
            <Heading variant="subtitle3">Twilio ID prefix</Heading>
            <OverlayTrigger placement="right">
              <Button variant="tool" icon={<Info />} />
              <Tooltip variant="info">
                When running the Call Center scenario, prefix your loyalty ID
                with these 5 digits and experience events will be sent to this
                sandbox.
              </Tooltip>
            </OverlayTrigger>
          </div>
          <div>{twilioPrefix}</div>
        </div>
        <Button
          variant="cta"
          onClick={() => history.push(`${PATHS.AEP_DETAILS}/${id}`)}>
          Details
        </Button>
      </section>
    </div>
  );
}
